export const QueryKey = {
	content: 'content',
	assets: 'assets',

	products: 'products',

	accessoryCategories: 'accessory-categories',
	accessories: 'accessories',
	creatorAccessories: 'creator-accessories',

	attributes: 'attributes',
	attributeValues: 'attribute-values',

	productTypeCategories: 'product-type-categories',
	productTypes: 'product-types',
	productTypeVariations: 'product-type-variations',

	doors: 'doors',

	offers: 'offers',
} as const;

export type QueryKey = (typeof QueryKey)[keyof typeof QueryKey];
